import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { userOwnerReducer } from './user-owner/user-owner.slice'

const reducer = combineReducers({
  userOwner: userOwnerReducer,
})

export type RootState = ReturnType<typeof reducer>

export const store = configureStore({
  reducer,
  devTools: process.env.NODE_ENV !== 'production' ? { name: 'PracticeBuilder' } : false
})

export type AppDispatch = typeof store.dispatch
